var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 16.1875V15.7917C7.875 13.5525 7.875 12.4329 8.57064 11.7373C9.26627 11.0417 10.3858 11.0417 12.625 11.0417H13.0208M13.4167 9.72995V7.08333C13.4167 4.09777 13.4167 2.60499 12.4891 1.67749C11.5617 0.75 10.0689 0.75 7.08333 0.75C4.09778 0.75 2.60499 0.75 1.67749 1.67749C0.75 2.60499 0.75 4.09777 0.75 7.08333V10.6808C0.75 13.2498 0.75 14.5343 1.45147 15.4043C1.59319 15.5801 1.75329 15.7401 1.92905 15.8818C2.79908 16.5833 4.08357 16.5833 6.65251 16.5833C7.21111 16.5833 7.49033 16.5833 7.74612 16.4931C7.79932 16.4743 7.85141 16.4527 7.90231 16.4284C8.14702 16.3113 8.34446 16.1139 8.73942 15.7189L12.4891 11.9692C12.9468 11.5115 13.1756 11.2827 13.2962 10.9917C13.4167 10.7008 13.4167 10.3771 13.4167 9.72995Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon2);
export default __webpack_public_path__ + "static/media/FileIcon2.cb23837a552eeaecb2862e63fda24c39.svg";
export { ForwardRef as ReactComponent };